<app-contact-form type="modal"></app-contact-form>